/* eslint-disable array-callback-return */
/* eslint-disable import/no-anonymous-default-export */
/* eslint-disable react/jsx-no-undef */
import React, { Component } from "react";
import {
  InputLabel,
  MenuItem,
  FormControl,
  Select,
  Box,
  Button,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { Edit } from "@material-ui/icons";
import ToPrintPageInsertScore from "../components/ToPrintPageInsertScore";
import ManageSearchIcon from "@mui/icons-material/ManageSearch"; //added on 23.09.2022
import UploadFileIcon from "@mui/icons-material/UploadFile"; //added on 01.04.2023
import CircularProgress, {
  circularProgressClasses,
} from "@mui/material/CircularProgress"; //added on 26.09.2022
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import Container from "@mui/material/Container";
import * as XLSX from "xlsx";
import { orange } from "@mui/material/colors";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

/*--------------- Functional Component : Loading Progress ------------*/
const LoadingProgress = (props) => {
  const { loading } = props;
  return loading ? (
    <Box sx={{ position: "relative", display: "inline-flex" }}>
      <CircularProgress
        variant="determinate"
        sx={{
          color: (theme) =>
            theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
        }}
        size={40}
        thickness={4}
      />
      <CircularProgress
        variant="indeterminate"
        disableShrink
        sx={{
          color: (theme) =>
            theme.palette.mode === "light" ? "#1a90ff" : "#308fe8",
          animationDuration: "550ms",
          position: "absolute",
          left: 0,
          [`& .${circularProgressClasses.circle}`]: {
            strokeLinecap: "round",
          },
        }}
        size={40}
        thickness={4}
      />
    </Box>
  ) : null;
};

/*------------------------- Functional Component : PageInsertScore ------------*/
class PageInsertScore extends Component {
  /*---------- updated on 24.09.2022 >>> alignment & text color ---------*/
  constructor(props) {
    super(props);
    this.columns = [
      {
        field: "id",
        headerName: "ลำดับ",
        width: 60,
        headerAlign: "center",
        align: "center",
        valueGetter: (params) => params.api.getRowIndex(params.row.persid) + 1,
      },
      {
        field: "studentid",
        headerName: "เลขประจำตัว",
        width: 110,
        headerAlign: "center",
        align: "center",
      },
      {
        field: "studentname",
        headerName: "ยศ ชื่อ สกุล",
        width: 150,
        headerAlign: "center",
      },
      {
        field: "leaveday",
        headerName: "วันที่ลา",
        width: 70,
        align: "center",
        headerAlign: "center",
        renderCell: (params) => {
          return (
            <>
              <Link
                to="/PageEditInsertScore"
                state={{
                  id: params.id,
                  prev_page: 0,
                  newdatastorage: "",
                }}
              >
                <Edit className="userListDate" />
              </Link>
            </>
          );
        },
      },
      {
        field: "period",
        headerName: "ระยะเวลาการศึกษา(ชั่วโมง)",
        width: 150,
        headerAlign: "center",
        align: "center",
      },
      {
        field: "businessleave",
        headerName: "จำนวนชั่วโมงลากิจ",
        width: 150,
        headerAlign: "center",
        align: "center",
      },
      {
        field: "sickleave",
        headerName: "จำนวนชั่วโมงลาป่วย",
        width: 150,
        headerAlign: "center",
        align: "center",
      },
      {
        field: "sumattendhrs",
        headerName: "รวมเวลามาเรียน",
        width: 130,
        headerAlign: "center",
        align: "center",
      },
      {
        field: "percentattendhrs",
        headerName: "ร้อยละเวลามาเรียน",
        width: 150,
        headerAlign: "center",
        align: "center",
      },
      {
        field: "conductscore",
        headerName: "คะแนนความประพฤติ",
        width: 150,
        headerAlign: "center",
        align: "center",
        editable: true,
      },
      {
        field: "status",
        headerName: "สถานะ",
        width: 100,
        headerAlign: "center",
        align: "center",
        renderCell: (params) => {
          return (
            <>
              {Number(params.getValue(params.id, "percentattendhrs")) >= 80 ? (
                <div style={{ color: "#018822", fontWeight: "bold" }}>ผ่าน</div>
              ) : (
                <div style={{ color: "#A50000", fontWeight: "bold" }}>
                  ไม่ผ่าน
                </div>
              )}
            </>
          );
        },
      },
      {
        field: "remark",
        headerName: "หมายเหตุ",
        width: 150,
        headerAlign: "center",
        align: "center",
        renderCell: (params) => (
          <>
            {parseInt(params.getValue(params.id, "conductscore")) !== 0 ? (
              <div style={{ color: "#018822", fontWeight: "bold" }}>
                เรียบร้อยแล้ว
              </div>
            ) : (
              <div style={{ color: "#A50000", fontWeight: "bold" }}>
                ยังไม่ได้ใส่คะแนน
              </div>
            )}
          </>
        ),
      },
    ];

    this.state = {
      courseid: localStorage.getItem("AccessRights").substring(11, 14), //--added on 24.09.2022
      coursegrplist: [],
      seminarlist: [],
      datagridrows: [],
      seldatagridrows: [],
      selcoursegrp: "",
      selcoursegrp_indx: "",
      selseminar: "",
      selseminar_indx: "",
      instrlist: [],
      dataPassedToNextComp: [],
      loading: false, //Loading Progress State
      btnuploadenable:
        localStorage.getItem("Access") === "กรรมวิธี" ||
        localStorage.getItem("Access") === "ปกครอง"
          ? true
          : false, //added on 12042023
    };

    this.acceptBtnOnClick = this.acceptBtnOnClick.bind(this);
    this.handleCourseGrpSelect = this.handleCourseGrpSelect.bind(this);
    this.handleSeminarSelect = this.handleSeminarSelect.bind(this);
    this.handleStudBehaveScore = this.handleStudBehaveScore.bind(this);
  }

  componentDidMount() {
    this.createCourseGrpAndSeminarList();
  }

  /*----------------------- Event ---------------------------*/
  acceptBtnOnClick = () => {
    this.setState({ loading: true }); //Start Data Loading
    this.fetchdataToCreateDataGridRows(
      this.state.selcoursegrp,
      this.state.selseminar
    );
  };

  handleCourseGrpSelect = (event, child) => {
    const arr = Object.values(child)[4].children.split(" ");
    this.setState({
      selcoursegrp: parseInt(arr[1]),
      selcoursegrp_indx: this.state.coursegrplist.findIndex((e) =>
        e.includes(arr[1])
      ),
    });
    this.setState({ datagridrows: [] });
    this.setState({ loading: false });
  };

  /*-------------------- updated on 23.09.2022  -----------*/
  handleSeminarSelect = (event, child) => {
    this.setState({
      selseminar: event.target.value,
      selseminar_indx: event.target.value,
    });
    this.setState({ datagridrows: [] });
    this.setState({ loading: false });
  };

  handleStudBehaveScore = async (event, child) => {
    let rel_stud = this.state.datagridrows
      .map((e) => e)
      // .filter((e) => e.id === event.id);
      .filter((e) => e.persid === event.id);
    const id = localStorage.getItem("AccessRights").substring(0, 10);
    if (rel_stud[0]?.conductscore !== event.value) {
      rel_stud[0].conductscore = event.value;
      const token = localStorage.getItem("token");
      Object.assign(rel_stud[0], { InstructorId: id });
      let success = await axios
        .put(
          process.env.REACT_APP_API +
            `/PageInsertScore/lastestscore?token=${token}`,
          rel_stud
        )
        .catch((err) => {
          if (err.response.data.message) {
            toast.error("กรุณาเข้าระบบใหม่อีกครั้ง");
            this.props.navigate("/");
            localStorage.clear();
          } else {
            console.log("err: ", err.response.data);
          }
        });
      //   console.log('handleStudBehaveScore :: ', success);

      if (success !== undefined) {
        this.fetchdataToCreateDataGridRows(
          this.state.selcoursegrp,
          this.state.selseminar
        );
      }
    }
  };

  /*---------------------------------------------------------*/
  fetchdataToCreateDataGridRows = async (_coursegrp, _seminar) => {
    //console.log('fetchdataToCreateDataGridRows ', _coursegrp, ' : ', _seminar);
    const token = JSON.parse(localStorage.getItem("token"));
    localStorage.removeItem("datastorage");
    const courId = localStorage.getItem("AccessRights").substring(11, 14);
    let results = await axios
      .get(
        process.env.REACT_APP_API +
          `/PageInsertScore/coursegrp/${_coursegrp}/${_seminar}/${courId}?token=${token}`
      )
      .catch((err) => {
        if (err.response.data.message) {
          toast.error("กรุณาเข้าระบบใหม่อีกครั้ง");
          this.props.navigate("/");
          localStorage.clear();
        } else {
          console.log("err: ", err.response);
        }
      });

    //console.log('PageInsertScore >>>> fetchdataToCreateDataGridRows : ', results.data);

    /*----------------- update on 06042023 (sort) -------------------------*/
    // let newarr = results.data.sort((a, b) => (a.studentid > b.studentid) ? 1 : ((b.studentid > a.studentid) ? -1 : 0));
    // newarr.map((e, i) => { e.id = (i + 1) });
    // newarr.map((e, i) => { e.id = (i + 1) });
    //this.setState({ datagridrows: results.data });
    const sortSTU = results.data.sort((a, b) => {
      const numA = parseInt(a.studentid, 10);
      const numB = parseInt(b.studentid, 10);
      return numA - numB;
    });
    const newarr = sortSTU.sort((a, b) => a.seminar - b.seminar);
    localStorage.setItem(
      "datastorage",
      JSON.stringify(
        newarr.map((e) =>
          Object.assign(e, {
            courseid: courId,
            coursegrp: _coursegrp,
            seminar: _seminar,
            pageinsertscore: 1,
          })
        )
      )
    );
    this.setState({ datagridrows: sortSTU });
    this.setState({ loading: false }); //added on 26.09.2022
  };

  /*-------------------- updated on 23.09.2022 >>> add unshift('ทุกสัมมนา') -----------*/
  createCourseGrpAndSeminarList = async () => {
    const token = JSON.parse(localStorage.getItem("token"));
    const courId = localStorage.getItem("AccessRights").substring(11, 14);
    let datalist = await axios
      .get(
        process.env.REACT_APP_API + `/PageInsertScore/${courId}?token=${token}`
      )
      .catch((err) => {
        if (err.response.data.message) {
          toast.error("กรุณาเข้าระบบใหม่อีกครั้ง");
          this.props.navigate("/");
          localStorage.clear();
        } else {
          console.log("err: ", err.response.data);
        }
      });
    datalist.data.seminar.unshift("ทุกสัมมนา"); //added on 23.09.2022
    this.setState({
      coursegrplist: datalist.data.coursegrp,
      seminarlist: datalist.data.seminar,
    });

    /*------------------- get props from pageeditinsertscore ---------------*/
    if (this.props.location.state !== null) {
      this.setState({ loading: true });
      this.fetchdataToCreateDataGridRows(
        this.props.location.state.coursegrp,
        this.props.location.state.seminar
      );

      /*---------------- updated on 23.09.2022 ---------------*/
      let props_sem =
        this.props.location.state.seminar === "0"
          ? "0"
          : this.props.location.state.seminar;

      this.setState({
        selcoursegrp: this.props.location.state.coursegrp,
        selcoursegrp_indx: this.state.coursegrplist.findIndex((e) =>
          e.includes(this.props.location.state.coursegrp)
        ),
        selseminar: props_sem,
        selseminar_indx: props_sem,
      });
    }
  };

  /*--------------- added on 26.09.2022 ----------------*/
  loadingProgress = () => {
    if (this.state.loading) {
      return (
        <Box display={"flex"} justifyContent={"center"}>
          <LoadingProgress loading={this.state.loading} />
        </Box>
      );
    }
  };

  /*-------------------- added on 02042023 ----------------------*/
  formatExcelLayout = (data) => {
    let newformat = {
      persid: data[3]?.toString(),
      conductscore: data[6],
      coursegrp: data[2],
      courseid: data[0],
      InstructorId: localStorage.getItem("AccessRights").substring(0, 10),
    };
    return newformat;
  };

  addScoreFromExcelFile = async (xlsxscore) => {
    const token = localStorage.getItem("token");

    /*---------------- filter to get only completed data to upload -----------------*/
    let acceptlist = xlsxscore.filter((e) => {
      return (
        e.persid !== null &&
        e.persid?.length === 10 &&
        Object.values(e).some((el) => el != null) &&
        typeof e.conductscore === "number"
      );
    });

    /*---------------- filter to get only uncompleted data to edit -----------------*/
    let notacceptlist = xlsxscore.filter((e) => {
      return (
        e.persid === null ||
        e.persid?.length !== 10 ||
        Object.values(e).some((el) => el == null) ||
        typeof e.conductscore !== "number"
      );
    });

    // if (acceptlist.length !== 0) {
    if (notacceptlist.length === 0) {
      let promise = new Promise((resolve, reject) => {
        acceptlist.map(async (e) => {
          let tmparr = [];
          tmparr.push(e);
          try {
            let res = await axios.put(
              process.env.REACT_APP_API +
                `/PageInsertScore/lastestscore?token=${token}`,
              tmparr
            );
            if (res.status === 200) {
              resolve(res.data);
            } else {
              reject(Error(res.statusText));
            }
          } catch (err) {
            if (err.response.data.message) {
              toast.error("กรุณาเข้าระบบใหม่อีกครั้ง");
              this.props.navigate("/");
              localStorage.clear();
            } else {
              console.log(
                "PageInsertScore addScoreFromExcelFile failed >>> err: ",
                err.response.data
              );
            }
          }
        });
      });

      toast.promise(
        promise.then(
          (data) => {
            console.log(data);
          },
          (err) => {
            console.log(err);
          }
        ),
        {
          pending: {
            render: "กำลังอัพโหลดข้อมูลจากไฟล์ Excel ลงฐานข้อมูล",
            delay: undefined,
          },
          success: {
            render() {
              let persidlist = [];
              notacceptlist.forEach((e) => {
                persidlist.push(e.persid);
              });
              return `อัพโหลดข้อมูลจากไฟล์ Excel ลงฐานข้อมูลเรียบร้อยแล้ว จำนวน ${acceptlist.length} ข้อมูล มีปัญหาจำนวน ${notacceptlist.length} ข้อมูล (เลขประจำตัวข้าราชการ : ${persidlist}) `;
            },
          },
          error: {
            render({ data }) {
              this.props.navigate("/");
              localStorage.clear();
              return `ไม่สามารถอัพโหลดข้อมูลจากไฟล์ Excel ลงฐานข้อมูลได้ เนื่องจาก ${data.message}`;
            },
          },
        },
        {
          position: toast.POSITION.TOP_CENTER,
          delay: 3000,
        }
      );
    } else {
      toast.error("กรุณาตรวจสอบความถูกต้องของข้อมูลที่ต้องการอัพโหลดอีกครั้ง", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };

  UploadBtnOnClick = (e) => {
    let formatxlsxlist = [];
    if (e.target.files.length) {
      const reader = new FileReader();
      reader.readAsArrayBuffer(e.target.files[0]);
      reader.onload = (e) => {
        const data = e.target.result;
        const workbook = XLSX.read(data, { type: "array" });
        const sheetname = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetname];
        const json = XLSX.utils.sheet_to_json(worksheet, {
          header: 1,
          blankrows: false,
        });
        if (reader.readyState === 2) {
          for (let indx = 2; indx < json.length; indx++) {
            formatxlsxlist.push(this.formatExcelLayout(json[indx]));
          }
          this.addScoreFromExcelFile(formatxlsxlist);
          // toast.promise(this.addScoreFromExcelFile(formatxlsxlist), {
          //   pending: {
          //     render: 'กำลังอัพโหลดข้อมูลจากไฟล์ Excel ลงฐานข้อมูล',
          //     delay: undefined
          //   },
          //   success: 'อัพโหลดข้อมูลจากไฟล์ Excel ลงฐานข้อมูลเรียบร้อยแล้ว',
          //   error: {
          //     render({ data }) {
          //       console.log('ไม่สามารถอัพโหลดข้อมูลจากไฟล์ Excel ลงฐานข้อมูลได้ เนื่องจาก ', data.message);
          //     }
          //   }
          // }, {
          //   position: toast.POSITION.TOP_CENTER,
          //   delay: 500
          // });
        }
      };
    }
  };
  /*--------------------------- Render : Class -------------------------*/
  render() {
    //console.log('loading ', this.state.loading);
    return (
      <React.Fragment>
        <div className="cotainerDetail">
          <p className="HeadTextMain" sx={{ fontWeight: "bold" }}>
            ชั่วโมงการศึกษาและคะแนนความประพฤติ
          </p>
          <div className="DropdownSelectModel">
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <FormControl sx={{ m: 1, minWidth: 100 }}>
                <InputLabel
                  htmlFor="grouped-select"
                  sx={{
                    fontFamily: "THSarabunNew",
                    fontWeight: "bold",
                    fontSize: 16,
                  }}
                >
                  รุ่น
                </InputLabel>
                <Select
                  sx={{
                    fontFamily: "THSarabunNew",
                    fontWeight: "bold",
                    fontSize: 16,
                  }}
                  value={this.state.selcoursegrp_indx}
                  id="grouped-select"
                  label="รุ่น"
                  onChange={this.handleCourseGrpSelect}
                >
                  {this.state.coursegrplist.map((item, index) => {
                    return (
                      <MenuItem
                        key={index}
                        value={index}
                        sx={{
                          fontFamily: "THSarabunNew",
                          fontWeight: "bold",
                          fontSize: 16,
                        }}
                      >
                        {item}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
              <FormControl sx={{ m: 1, minWidth: 100 }}>
                <InputLabel
                  htmlFor="seminar-select"
                  sx={{
                    fontFamily: "THSarabunNew",
                    fontWeight: "bold",
                    fontSize: 16,
                  }}
                >
                  สัมมนา
                </InputLabel>
                <Select
                  sx={{
                    fontFamily: "THSarabunNew",
                    fontWeight: "bold",
                    fontSize: 16,
                  }}
                  value={this.state.selseminar_indx}
                  id="seminar-select"
                  label="สัมมนา"
                  onChange={this.handleSeminarSelect}
                >
                  {this.state.seminarlist.map((item, index) => {
                    return (
                      <MenuItem
                        key={index}
                        value={index}
                        sx={{
                          fontFamily: "THSarabunNew",
                          fontWeight: "bold",
                          fontSize: 16,
                        }}
                      >
                        {item}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
              <Button
                variant={"contained"}
                sx={{
                  minWidth: 100,
                  minHeight: 55,
                  m: 1,
                  fontFamily: "THSarabunNew",
                  fontWeight: "bold",
                  fontSize: 16,
                }}
                startIcon={<ManageSearchIcon />} //add on 23.09.2022
                onClick={this.acceptBtnOnClick}
              >
                ตกลง
              </Button>
              <input
                style={{ display: "none" }}
                id="btn-fileupload"
                multiple
                type="file"
                onChange={(e) => this.UploadBtnOnClick(e)}
              />
              <label htmlFor="btn-fileupload">
                {this.state.btnuploadenable && (
                  <Button
                    variant="contained"
                    sx={{
                      minWidth: 100,
                      minHeight: 55,
                      m: 1,
                      fontFamily: "THSarabunNew",
                      fontWeight: "bold",
                      fontSize: 16,
                      backgroundColor: orange["A700"],
                    }}
                    startIcon={<UploadFileIcon />}
                    component="span"
                    onClick={() => {
                      this.setState({
                        selcoursegrp: "",
                        selcoursegrp_indx: "",
                        selseminar: "",
                        selseminar_indx: "",
                        datagridrows: [],
                      });
                    }}
                  >
                    อัพโหลดคะแนน
                  </Button>
                )}
              </label>
            </Box>
          </div>

          {/*------- updated on 23.09.2022 -> change color and fontweght ----*/}
          <Container>
            <Box component={"span"} sx={{ display: "block" }}>
              <ToPrintPageInsertScore
                dataToPrint={{
                  courseid: this.state.courseid,
                  coursegrp: this.state.selcoursegrp,
                  seminar: this.state.selseminar,
                }}
              />
            </Box>
            <Box
              component={"span"}
              sx={{
                display: "block",
                justifyContent: "center",
                height: 700,
                "& .normal": {
                  fontWeight: "bold",
                  color: "#018822",
                  backgroundColor: "#F0F1F1",
                },
                "& .urgent": {
                  fontWeight: "bold",
                  color: "#A50000",
                  backgroundColor: "#F0F1F1",
                },
              }}
            >
              <DataGrid
                getRowId={(row) => row.persid}
                rows={this.state.datagridrows}
                columns={this.columns}
                pageSize={10}
                //rowsPerPageOptions={[5, 10]}
                onCellEditCommit={this.handleStudBehaveScore}
                getCellClassName={(params) => {
                  if (params.field === "conductscore") {
                    return parseInt(params.value) !== 0 ? "normal" : "urgent";
                  }
                }}
                loading={
                  this.loadingProgress() //added on 26.09.2022
                }
              />
            </Box>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default () => (
  <PageInsertScore location={useLocation()} navigate={useNavigate()} />
);
